import React from 'react';
import { StaticImage } from 'gatsby-plugin-image';
import * as styles from './Marker.module.scss';
import '~/styles/_module.scss';

const Marker = ({ alt, aizu, aict }) => (
  <>
    {aizu === true && <div className={styles.toolTips}>会津ラボ</div>}
    {aict === true && <div className={styles.toolTips}>AiCT</div>}
    {/* <div className={styles.toolTips}>AiCT</div> */}
    <StaticImage
      src="../../images/common/marker.png"
      alt={alt}
      width={67}
      height={79}
      placeholder="none"
      className={styles.marker}
    />
  </>
);

export default Marker;
